/**
 * MetaphorGlyphs
 *
 * Purpose: Line drawings for the three approved ICE metaphors (film frames, library shelves, feedback loop).
 * Data schema: Props accept className (string). Colour comes from currentColor.
 * Accessibility: Decorative only (aria-hidden); the adjacent heading carries the meaning.
 */
import React from "react";

const svgProps = {
  viewBox: "0 0 96 64",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: "false",
};

// One rectangle per conversational turn, with sprocket holes. The third frame is "this turn".
export const FilmFramesGlyph = ({ className = "" }) => (
  <svg {...svgProps} className={className}>
    {[3, 27, 51, 75].map((x, i) => (
      <g key={x}>
        <rect x={x} y="14" width="18" height="36" rx="2" fill={i === 2 ? "currentColor" : "none"} fillOpacity={i === 2 ? 0.18 : 0} />
        <rect x={x + 7} y="5" width="4" height="4" rx="1" />
        <rect x={x + 7} y="55" width="4" height="4" rx="1" />
      </g>
    ))}
  </svg>
);

// Four shelves, one per lane: episodic, semantic, procedural, working.
const SHELVES = [
  { y: 15, books: [8, 6, 9, 7, 8, 6, 9, 7] },
  { y: 31, books: [6, 9, 7, 8, 6, 9, 7, 8] },
  { y: 47, books: [9, 7, 8, 6, 9, 7, 8, 6] },
  { y: 63, books: [7, 8, 6, 9, 7, 8, 6, 9] },
];
export const LibraryShelvesGlyph = ({ className = "" }) => (
  <svg {...svgProps} className={className}>
    {SHELVES.map(({ y, books }) => (
      <g key={y}>
        <line x1="4" y1={y} x2="92" y2={y} />
        {books.map((h, i) => (
          <rect key={i} x={10 + i * 10} y={y - h} width="5" height={h} rx="0.5" />
        ))}
      </g>
    ))}
  </svg>
);

// A loop that returns to where it started: one session hands its memory to the next, which hands it back.
export const FeedbackLoopGlyph = ({ className = "" }) => (
  <svg {...svgProps} className={className}>
    <path d="M30 14 H66 A18 18 0 0 1 66 50 H30 A18 18 0 0 1 30 14 Z" />
    <path d="M-4 -4 L2 0 L-4 4" transform="translate(50 14)" />
    <path d="M-4 -4 L2 0 L-4 4" transform="translate(46 50) rotate(180)" />
    <circle cx="12" cy="32" r="3" fill="currentColor" fillOpacity="0.18" />
    <circle cx="84" cy="32" r="3" fill="currentColor" fillOpacity="0.18" />
  </svg>
);
